/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdApplicationPublicDataBuilderVkontakteComVkIdOptions
 */
export interface FxIdApplicationPublicDataBuilderVkontakteComVkIdOptions {
    /**
     * 
     * @type {number}
     * @memberof FxIdApplicationPublicDataBuilderVkontakteComVkIdOptions
     */
    ClientId: number;
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationPublicDataBuilderVkontakteComVkIdOptions
     */
    Scope?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FxIdApplicationPublicDataBuilderVkontakteComVkIdOptions
     */
    ShowOkLogin: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FxIdApplicationPublicDataBuilderVkontakteComVkIdOptions
     */
    ShowMailRuLogin: boolean;
}

/**
 * Check if a given object implements the FxIdApplicationPublicDataBuilderVkontakteComVkIdOptions interface.
 */
export function instanceOfFxIdApplicationPublicDataBuilderVkontakteComVkIdOptions(value: object): value is FxIdApplicationPublicDataBuilderVkontakteComVkIdOptions {
    if (!('ClientId' in value) || value['ClientId'] === undefined) return false;
    if (!('ShowOkLogin' in value) || value['ShowOkLogin'] === undefined) return false;
    if (!('ShowMailRuLogin' in value) || value['ShowMailRuLogin'] === undefined) return false;
    return true;
}

export function FxIdApplicationPublicDataBuilderVkontakteComVkIdOptionsFromJSON(json: any): FxIdApplicationPublicDataBuilderVkontakteComVkIdOptions {
    return FxIdApplicationPublicDataBuilderVkontakteComVkIdOptionsFromJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderVkontakteComVkIdOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationPublicDataBuilderVkontakteComVkIdOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'ClientId': json['ClientId'],
        'Scope': json['Scope'] == null ? undefined : json['Scope'],
        'ShowOkLogin': json['ShowOkLogin'],
        'ShowMailRuLogin': json['ShowMailRuLogin'],
    };
}

export function FxIdApplicationPublicDataBuilderVkontakteComVkIdOptionsToJSON(json: any): FxIdApplicationPublicDataBuilderVkontakteComVkIdOptions {
    return FxIdApplicationPublicDataBuilderVkontakteComVkIdOptionsToJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderVkontakteComVkIdOptionsToJSONTyped(value?: FxIdApplicationPublicDataBuilderVkontakteComVkIdOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ClientId': value['ClientId'],
        'Scope': value['Scope'],
        'ShowOkLogin': value['ShowOkLogin'],
        'ShowMailRuLogin': value['ShowMailRuLogin'],
    };
}

